// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__OfcCV","search":"Settings_search__2nQRO","filter":"Settings_filter__2nQcu"};